import moment from "moment";

// TODO remove eslint-disable (added during a merge)
// eslint-disable-next-line import/no-restricted-paths
import { IAppointmentEditModel } from "@/Appointments/Models/UI/IAppointmentEditModel";
import { Appointment } from "@/Common/Api/Appointment/Dto/Appointment";
import { Client } from "@/Common/Api/Client";
import { ClinicSettings } from "@/Common/Api/MedfarDictionaries/Dto/Responses/ClinicSettings";
import { BaseReactComponent } from "@/Common/Components/BaseReactComponent";
import { HyperLinkRedirectControl, HyperLinkRedirectControlPatientProfileSubTabs } from "@/Common/Components/Buttons/HyperLinkRedirectControl";
import { CheckboxControl } from "@/Common/Components/Inputs/CheckboxControl";
import { OntarioHealthInsurancePlanEligibilityIndicator } from "@/Common/Components/Patient/HealthCoverageStatus/OntarioHealthInsurancePlanEligibilityIndicator";
import { PatientBannerExternalIdentifiers } from "@/Common/Components/Patient/PatientBannerExternalIdentifiers";
import { PopulationBasedFundingStatusController } from "@/Common/Components/PopulationBasedFunding/PopulationBasedFundingStatusController";
import { InvitationPopup } from "@/Common/Components/Portal/InvitationPopup/InvitationPopup";
import { PortalStatusButton, PortalStatusIcon } from "@/Common/Components/Portal/PortalStatusIcon";
import { MyleHelper } from "@/Common/Helpers/MyleHelper";
import { PatientHelper } from "@/Common/Helpers/PatientHelper";
import { PortalHelper } from "@/Common/Helpers/PortalHelper";
import { AppointmentContactChannel } from "@/Common/Models/Appointments/AppointmentContactChannel";
import { Address } from "@/Common/Models/Contacts/Address";
import { Patient as MyleModelsPatientPatient } from "@/Common/Models/Patient/Patient";
import { OntarioPatientEnrollmentModel } from "@/Common/Models/Patient/PatientEnrollment/Ontario/OntarioPatientEnrollmentModel";
import { ProfileTab } from "@/Common/Models/Patient/PatientEnums";
import { IPatientBannerModel } from "@/Common/Models/Patient/UI/IPatientBannerModel";
import { Person } from "@/Common/Models/Person/Person";
import { SharedItemMessage } from "@/Common/Models/Portal/SharedItem/SharedItemMessage";
import { SitesModel } from "@/Common/Models/Sites/SitesModel";
import { RedirectTo } from "@/Common/Models/UI/Enums";
import { CheckboxTarget } from "@/Common/Models/UI/Inputs/CheckboxTarget";
import * as LocalOperations from "@/Common/Operations/operations.local";
import * as ServerOperations from "@/Common/Operations/operations.server";
import { CanadaState } from "@/Common/Resources/Lookups/Enums/CommonLookupCodes";
import { LocalEvent } from "@/Common/Stores/Actions/LocalEvent";
import { RouterHistory } from "@/Common/Utilities/Router/RouterHistory";
import { PortalCommunicationPreviewList } from "../SharedItem/PortalCommunicationPreviewList";
import { BritishColumbiaPatientBannerMspCoverage } from "./HealthCoverageStatus/BritishColumbiaPatientBannerMspCoverage";
import { PatientSubscription } from "./PatientSubscriptions/PatientSubscription";
import { PatientBannerHealthCoverage } from "./PatientBannerHealthCoverage";
import { PatientContactDisplay } from "./PatientContactDisplay";
import { PreferredPharmacyStatus } from "./PreferredPharmacyStatus";

import img_p_banner_icon_100 from "@/Globals/_images/p-banner-icon-100.png";

interface IPatientBannerVerticalProps {
    activeSite?: SitesModel;
    hasEmailNotificationsEnabled?: boolean;
    hasSmsNotificationsEnabled?: boolean;
    showPopulationBasedStatusIcon?: boolean;
    model: IPatientBannerModel;
    appointmentEditModel?: IAppointmentEditModel;
    recallCompleteOperation?: number;
    recallCompleteFunction?: (recallId: string) => void;
    hideWaitingList?: boolean;
    hideRelatedRecalls?: boolean;
    hideContact?: boolean;
    addPortalCommunicationSection?: boolean;
    portalCommunicationListUpdateKey?: number;
    dataCy?: string;
}

class PatientBannerVerticalState {
    public activeSite?: SitesModel;
    public ontarioPatientEnrollmentModel: OntarioPatientEnrollmentModel;
    public invitationPopupOpen: boolean;
    public patientPortalMessages: SharedItemMessage[];

    public constructor(fields?: Partial<PatientBannerVerticalState>) {
        Object.assign(this, fields);
        this.patientPortalMessages = [];
    }
}

class PatientBannerVertical extends BaseReactComponent<IPatientBannerVerticalProps, PatientBannerVerticalState> {
    private helper: MyleHelper = new MyleHelper();
    private mexicoCountryLookup = cacheStore.FindLookupByLookupCode("CNMEXICO");
    private readonly canShowPortalCommunication = cacheStore.ClinicSettings.EnableBidirectionalCommunication && cacheStore.ClinicSettings_Portal.EnablePortalWebsite;

    constructor(props: IPatientBannerVerticalProps) {
        super(props);

        this.state = this.createInitialState(this.getSelectedActiveSite(props.activeSite));
    }

    public componentDidMount(): void {
        if (this.isOntarioEnrollmentActive(this.props.activeSite))
            this.getOntarioEnrollmentStatus(this.props);

        if (this.canShowPortalCommunication && this.props.addPortalCommunicationSection)
            this.getPatientLastPortalMessages(this.props.model.get("Model")?.IndividualResponse?.Contact_id ?? "");
    }

    public componentDidUpdate(prevProps: IPatientBannerVerticalProps): void {
        if (
            this.props.model.get("Model") !== prevProps.model.get("Model")
            || this.props.activeSite !== prevProps.activeSite
            || this.props.addPortalCommunicationSection !== prevProps.addPortalCommunicationSection
            || this.props.portalCommunicationListUpdateKey !== prevProps.portalCommunicationListUpdateKey
        ) {
            if (this.canShowPortalCommunication && prevProps.portalCommunicationListUpdateKey !== this.props.portalCommunicationListUpdateKey) {
                this.getPatientLastPortalMessages(this.props.model.get("Model")?.IndividualResponse?.Contact_id ?? "");
                return;
            }

            if (this.isOntarioEnrollmentActive(this.props.activeSite)) {
                this.getOntarioEnrollmentStatus(this.props);
            }
            else {
                this.resetState(this.props.activeSite);
            }

            if (this.canShowPortalCommunication && this.props.addPortalCommunicationSection)
                this.getPatientLastPortalMessages(this.props.model.get("Model")?.IndividualResponse?.Contact_id ?? "");
        }
    }

    public render(): JSX.Element {
        try {
            return this.renderVertical(this.props.model.get("Model"));
        }
        catch (ex) {
            console.log(ex);
        }
    }

    private createInitialState(activeSite: SitesModel, patientEnrollment: OntarioPatientEnrollmentModel = null): PatientBannerVerticalState {
        return new PatientBannerVerticalState({
            activeSite,
            ontarioPatientEnrollmentModel: patientEnrollment,
            invitationPopupOpen: false
        });
    }

    private resetState(activeSite: SitesModel, patientEnrollment: OntarioPatientEnrollmentModel = null): void {
        this.mutateState(s => {
            s.activeSite = activeSite;
            s.ontarioPatientEnrollmentModel = patientEnrollment;
            s.invitationPopupOpen = false;
        });
    }

    private renderVertical(patient: MyleModelsPatientPatient): JSX.Element {
        if (patient == null || patient.IndividualResponse == null)
            return null;

        const appointment = this.props?.appointmentEditModel?.get("Appointment");

        const enableInvitationFlow = cacheStore.ClinicSettings?.EnablePortalInvitationFlowV2;

        const memoMessage = patient.IndividualResponse?.MemoNote ?? "";

        // upcoming appointment
        let upcomingAppointmentDisplay = <div>N/A</div>;
        if (patient.UpcomingAppointment) {
            let upcomingAppointment = patient.UpcomingAppointment;
            let today = upcomingAppointment.HasAppointmentToday ? `${cacheStore.GetString("TodayLabel")}.` : "";

            let nextAppDateDisplay = "";
            if (upcomingAppointment.DateTime != null) {
                today = today == "" ? "" : `${today.substring(0, 3)}+`;
                nextAppDateDisplay = moment(upcomingAppointment.DateTime).format("YYYY-MM-DD HH:mm A");
            }

            upcomingAppointmentDisplay = (
                <div>
                    <div>
                        <span className="red-text">{today} {nextAppDateDisplay}</span>
                    </div>
                    <div>
                        <span className="red-text">{upcomingAppointment.Subject}</span>
                    </div>
                </div>
            );
        }

        let formattedNAM = patient.GetFormattedNAM();

        // display healthcard as CURP if we are in mexico, NAM in QC, etc.
        const isMexicoCURP = patient.GetPrimaryHealthCardCountryLookupId() == this.mexicoCountryLookup.LookupID;

        // expired NAM display
        let expiredNAMrender: JSX.Element = null;
        if (!isMexicoCURP) {
            if (!IsNullOrWhiteSpace(formattedNAM)) {
                const expiry: Date = patient.GetNAMExpirationDate();
                if (expiry) {
                    if (moment(expiry).toDate() < new Date())
                        expiredNAMrender = <span className="red-text"> {cacheStore.GetString("ExpiredMLabel")} </span>;
                }
            }
        }

        const dobString = patient.IndividualResponse?.DateOfBirth
            ? patient.GetFormattedDateOfBirth() + " (" + PatientHelper.getFormattedAge(moment(patient.IndividualResponse.DateOfBirth).toDate(), moment().toDate()) + ") "
            : "";

        const patientPictureUrl = patient?.ProfilePicture
            ? apiSettings.buildAppUrl(`api/patient/profile/image/fetch/${patient.ProfilePicture.Id}?_nocache=${this.props.model.get("ProfileImageVersion")}`, { auth: true, noCache: false })
            : img_p_banner_icon_100;

        const portalButtonProps = cacheStore.ClinicSettings_Portal.EnablePortalWebsite
            ? PortalHelper.getPortalButtonPropsForRegistrationState(this.props.model?.get("Model")?.IndividualResponse?.PortalSyncState, true)
            : null;

        const contactIds = this.showNotification
            ? patient.getSelectedNotificationContactPointIds()
            : [];

        return (
            <div className="row">
                <div className="col-lg-12">
                    {/* patient name + health card */}
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="clearfix">
                                <div className="pull-left">
                                    <div className="pic-profile-wrp">
                                        <img src={patientPictureUrl} style={{ width: "48px", height: "48px" }} alt={patient.GetFormattedNameWithPrefix()} />
                                    </div>
                                </div>
                                {portalButtonProps && (
                                    <div className="pull-left" style={{ marginTop: "5px", marginLeft: "5px" }}>
                                        {enableInvitationFlow ? (
                                            <PortalStatusButton
                                                className="push-right-5"
                                                onClick={() => this.openInvitationPopup()}
                                                {...portalButtonProps}
                                            />
                                        ) : (
                                            <PortalStatusIcon className="push-right-5" {...portalButtonProps} />
                                        )
                                        }
                                    </div>
                                )}
                                <div className="pull-left" style={{ margin: "0 0 0 8px" }}>
                                    <div className="flex-display" data-cy={this.props.dataCy}>
                                        <HyperLinkRedirectControl
                                            target={RedirectTo.Patient}
                                            redirectValue={patient.IndividualResponse?.Contact_id}
                                            text={patient.GetFormattedNameWithPrefix()}
                                        />
                                        <span style={{ marginLeft: ".5rem" }}>{patient.GetFormattedPreferredPronouns()}</span>
                                    </div>

                                    <div className="flex-container flex-start" style={{ gap: "8px" }}>
                                        <span className="form-text">{formattedNAM} </span>
                                        {!isMexicoCURP && <span>{patient.GetFormattedNAMExpirationDateString()}</span>}
                                        {!isMexicoCURP && <span>{expiredNAMrender}</span>}
                                        {cacheStore.ClinicSettings.EnableMedicalServicesPlanEligibility && this.isBritishColumbiaPatient() && cacheStore.ClinicSettings.EnablePopulationBasedFunding && (
                                            <span>
                                                <BritishColumbiaPatientBannerMspCoverage
                                                    patient={new MyleModelsPatientPatient(patient)}
                                                    dateOfBirth={patient.IndividualResponse?.DateOfBirth}
                                                />
                                            </span>
                                        )}
                                        {cacheStore.ClinicSettings.EnableOntarioHealthInsurancePlanEligibility && (
                                            <span>
                                                <OntarioHealthInsurancePlanEligibilityIndicator
                                                    patientHealthCardNumberWithVersion={patient.HealthCards?.[0]?.Number}
                                                />
                                            </span>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* patient identifiers */}
                    <div className="row">
                        <div className="col-lg-12">
                            <div>
                                <span className="graytext">#1. </span><span className="form-text">{patient.PatientResponse != null ? patient.PatientResponse.Identifier01 : ""}</span>
                            </div>
                            <div>
                                <span className="graytext">#2. </span><span className="form-text">{patient.PatientResponse != null ? patient.PatientResponse.Identifier02 : ""}</span>
                            </div>
                            <div>
                                <span className="graytext">#3. </span><span className="form-text">{patient.PatientResponse != null ? patient.PatientResponse.Identifier03 : ""}</span>
                            </div>
                            <PatientBannerExternalIdentifiers
                                patient={patient}
                            />
                        </div>
                    </div>
                    {/* patient D.O.B */}
                    <div className="row">
                        <div className="col-lg-12">
                            <div>
                                <span className="graytext">{cacheStore.GetString("BornDLabel")}</span> <span className="form-text"> {dobString}</span>
                            </div>
                        </div>
                    </div>
                    {/* patient Gender */}
                    <div className="row">
                        <div className="col-lg-12">
                            <div>
                                <span className="graytext">{cacheStore.GetString("SexAtBirthLabel")}</span> <span className="form-text">{patient.GetFormattedGender()}</span>
                            </div>
                        </div>
                    </div>

                    {/* Family Doctor */}
                    {!sessionStore.getCurrentEmployee().isActiveSiteMexico() &&
                        this.renderHeaderSection("AssignedCareTeamAndEnrolmentLabel")
                    }
                    {!sessionStore.getCurrentEmployee().isActiveSiteMexico() && (
                        <div className="row">
                            <div className="col-lg-12">
                                <>
                                    {cacheStore.ClinicSettings.EnablePopulationBasedFunding && (
                                        <PopulationBasedFundingStatusController
                                            practician={patient?.GetAttendingDoctorOrSpecialistOnfileIntervenor()}
                                            patientContactFacetId={patient?.PatientResponse?.ContactFacet_id}
                                            showPracticianName={true}
                                            showCheckbox
                                        />
                                    )}
                                    {!sessionStore.getCurrentEmployee().isActiveSiteMexico() && !cacheStore.ClinicSettings.EnablePopulationBasedFunding && (
                                        <PatientBannerHealthCoverage
                                            patient={new MyleModelsPatientPatient(patient)}
                                            site={sessionStore.getCurrentEmployee().getActiveSite()}
                                            clinicSettings={new ClinicSettings(cacheStore.ClinicSettings)}
                                            ontarioPatientEnrollmentModel={new OntarioPatientEnrollmentModel(this.state.ontarioPatientEnrollmentModel)}
                                            onEnrollmentStatusClick={() => this.redirectToEnrollment(patient.IndividualResponse?.Contact_id)}
                                        />
                                    )}
                                    <PreferredPharmacyStatus
                                        patientContactId={patient.IndividualResponse?.Contact_id}
                                        customPharmacy={patient.PreferredPharmacy?.CustomPharmacy}
                                        directoryPharmacyId={patient.PreferredPharmacy?.DirectoryPharmacyId}
                                        directoryPharmacy={patient.PreferredPharmacy?.getDirectoryPharmacy()}
                                        includeRelativeMaxWidth
                                    />
                                </>
                            </div>
                        </div>
                    )}

                    {/* Patient subscription */}
                    {cacheStore.ClinicSettings.EnablePatientSubscription && (
                        <div>
                            {this.renderHeaderSection("PatientSubscription_TitleLabel")}
                            <div className="row">
                                <div className="col-lg-12">
                                    <PatientSubscription
                                        patient={patient}
                                    />
                                </div>
                            </div>
                        </div>
                    )}

                    {/* Patient Memo Insert */}
                    {memoMessage.length > 0 && this.renderHeaderSection("MemoLabel")}
                    {memoMessage.length > 0 && (
                        <div className="row">
                            <div className="col-lg-12">
                                <span>{memoMessage}</span>
                            </div>
                        </div>
                    )}

                    {/* Upcoming appointment */}
                    {this.renderHeaderSection("UpcomingApptBannerLabel")}
                    <div className="row">
                        <div className="col-lg-12">
                            {upcomingAppointmentDisplay}
                        </div>
                    </div>

                    {/* Patient portal communication messages */}
                    {this.canShowPortalCommunication
                        && this.props.addPortalCommunicationSection
                        && this.state.patientPortalMessages?.length
                        && (
                            <>
                                {this.renderHeaderSection("SharedItem_PortalCommunicationsLabel", "patient-banner-portal-communication-label")}
                                <div className="row">
                                    <div className="col-lg-12">
                                        <PortalCommunicationPreviewList
                                            sharedItemMessages={this.state.patientPortalMessages}
                                        />
                                    </div>
                                </div>
                            </>
                        )
                    }

                    {/* Clinical Waiting List */}
                    {!this.props.hideWaitingList && this.renderWaitingList(patient)}

                    {/* Related Recalls appointment */}
                    {!this.props.hideRelatedRecalls && this.renderRelatedRecalls(patient)}

                    {/* Hub Contacts */}

                    {appointment?.IsExternallyBookedAppointment &&
                        this.renderHeaderSection("HubContactLabel")
                    }
                    {appointment?.IsExternallyBookedAppointment &&
                        this.renderHubContactData(appointment)
                    }

                    {/* Contacts */}
                    {!this.props.hideContact && (
                        <PatientContactDisplay
                            patient={patient}
                            shouldRenderAllContactTypes={true}
                            showNotificationCheckbox={!!this.props?.appointmentEditModel?.get("Appointment")}
                            isNotificationSet={this.isQuestionnaireSet || this.props.appointmentEditModel?.get("NotifyPatient")}
                            sendToAllPersonalContact={this.props.appointmentEditModel?.get("SendToAllPersonalContacts")}
                            contactPointNotificationIds={contactIds}

                            hasEmailNotificationsEnabled={!appointment?.IsExternallyBookedAppointment && this.props.hasEmailNotificationsEnabled}
                            hasSmsNotificationsEnabled={!appointment?.IsExternallyBookedAppointment && this.props.hasSmsNotificationsEnabled}

                            onSendToAllPersonalContactChange={checked => sessionStore.dispatch(LocalOperations.Calendar.AppointmentEdit_IsSendNotificationsToAllPersonalContactsChecked, { checked })}
                            onPhoneNotificationChange={(checked, phone) => sessionStore.dispatch(LocalOperations.Calendar.AppointmentEdit_IsContactPointNotificationChecked, { checked, target: CheckboxTarget.Myle_Patient_Appointment_CellNotification, item: phone })}
                            onEmailNotificationChange={(checked, email) => sessionStore.dispatch(LocalOperations.Calendar.AppointmentEdit_IsContactPointNotificationChecked, { checked, target: CheckboxTarget.Myle_Patient_Appointment_EmailNotification, item: email })}
                            onRepresentativePhoneNotificationChange={(checked, phone) => sessionStore.dispatch(LocalOperations.Calendar.AppointmentEdit_IsContactPointNotificationChecked, { checked, target: CheckboxTarget.Myle_Patient_Appointment_RepresentativeCellNotification, item: phone })}
                            onRepresentativeEmailNotificationChange={(checked, email) => sessionStore.dispatch(LocalOperations.Calendar.AppointmentEdit_IsContactPointNotificationChecked, { checked, target: CheckboxTarget.Myle_Patient_Appointment_RepresentativeEmailNotification, item: email })}
                        />
                    )}

                    {this.getAddressSection(patient)}
                </div>

                {enableInvitationFlow && this.state.invitationPopupOpen && (
                    <InvitationPopup
                        person={Person.FromPatient(patient)}
                        onCancel={() => this.closeInvitationPopup()}
                    />
                )}
            </div>
        );
    }

    private renderHubContactData(appointment: Appointment): JSX.Element {
        const contactData = appointment.PatientSnapshot.ContactData;
        if (!contactData?.length)
            return null;

        return (
            <div>
                {contactData.map((contact, idx) => {
                    let label = "";
                    switch (contact.Action) {
                        case AppointmentContactChannel.Sms:
                            label = "SMSLabel";
                            break;
                        case AppointmentContactChannel.Phone:
                            label = "CallLabel";
                            break;
                        case AppointmentContactChannel.Email:
                            label = "EmailLabel";
                            break;
                    }
                    return this.renderExternalContactInfoRow(idx.toString(), label, contact.Value, contact.IsPreferred);
                })}
            </div>
        );
    }

    private getAddressSection(patient: MyleModelsPatientPatient): JSX.Element {
        if (!patient?.Addresses?.length)
            return null;

        const addresses = patient.Addresses.map(res => Address.FromResponseModel(res));

        const currentAddress = addresses.firstPreferredOrDefault(p => p.IsPreferred);

        return (
            <div key={"address" + currentAddress.ContactPoint_id} className="row">
                <div className="col-lg-12" style={{ marginBottom: "5px" }}>
                    <label className="bold">{cacheStore.GetString("AddressLabel")}</label>
                </div>
                <div className="col-lg-12">
                    <div>{currentAddress.StreetAddress}</div>
                    <div>{currentAddress.City}, {currentAddress.State} {currentAddress.GetFormatedPostalCode()}</div>
                    <div>{currentAddress.Country}</div>
                    <div>{currentAddress.AddressType}</div>
                </div>
            </div>
        );
    }

    private renderHeaderSection(labelKey: string, dataCy: string = null): JSX.Element {
        return (
            <div className="row">
                <div className="col-lg-12">
                    <div className="grayunderline patient" data-Cy={dataCy}>
                        <span className="graytext">{cacheStore.GetString(labelKey)}</span>
                    </div>
                </div>
            </div>
        );
    }

    private renderExternalContactInfoRow(id: string, label: string, value: string, checkedValue: boolean): JSX.Element {
        if (IsNullOrWhiteSpace(value))
            return null;

        return (
            <div key={id} className="row">
                <div className="col-lg-4">
                    <CheckboxControl
                        id={id}
                        label={cacheStore.GetString(label)}
                        checked={checkedValue}
                        disabled
                    />
                </div>
                <div className="col-lg-8">
                    {value}
                </div>
            </div>
        );
    }

    private renderWaitingList(patient: MyleModelsPatientPatient): JSX.Element {
        let patientListDisplay = <li><span className="myle-icon-16 none" /><span>N/A </span></li>;
        if (patient.ClinicalWaitingLists) {
            const waitingLists = patient.ClinicalWaitingLists;
            let waitingListItem: React.ReactNode = <div>N/A</div>;
            if (waitingLists.any()) {
                waitingListItem = waitingLists.map(list => (
                    <div key={"item" + list.Id}>
                        <HyperLinkRedirectControl
                            target={RedirectTo.List}
                            redirectValue={list.Id}
                            text={list.Name}
                            listName={list.Name}
                        />
                    </div>
                ));
            }

            patientListDisplay = (
                <>
                    <div className="row paddingtop20">
                        <div className="col-lg-12">
                            <div className="grayunderline patient">
                                <span className="graytext "> {cacheStore.GetString("ClinicalWaitingListLabel")}</span>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-lg-12">
                            <div>
                                {waitingListItem}
                            </div>
                        </div>
                    </div>
                </>
            );
        }

        return patientListDisplay;
    }

    private renderRelatedRecalls(patient: MyleModelsPatientPatient): JSX.Element {
        let relatedRecallsDisplay: JSX.Element = null;
        if (patient.RelatedRecalls) {
            let relatedRecalls = patient.RelatedRecalls;
            let relatedRecallsItem: React.ReactNode = <div>N/A</div>;
            if (relatedRecalls.length > 0) {
                relatedRecallsItem = relatedRecalls.map(recall => {
                    const dateString = moment(recall.DueDate).format("YYYY-MM-DD");
                    const employeeString = cacheStore.GetCliniciansPersonsByContactId(recall.DoctorContactId)?.Name ?? "N/A";

                    return (
                        <div key={"item" + recall.Id}>
                            <div className="bolded"> {this.helper.ShortenStringWithEllipsis(dateString + " - " + employeeString, 32)}- <a onClick={this.completeRecallOnClick.bind(this, recall.Id)} href="#"> ({cacheStore.GetString("CompleteLabel")}) </a> </div>
                            <div className="red-text ellipsis-auto" title={recall.Type} style={{ maxWidth: "20vw" }}> {recall.Type} </div>
                        </div>
                    );
                });
            }

            relatedRecallsDisplay = (
                <div>
                    <div className="row paddingtop20">
                        <div className="col-lg-12">
                            <div className="grayunderline patient">
                                <span className="graytext "> {cacheStore.GetString("RelatedRecallsLabel")}</span>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-lg-12">
                            <div>
                                {relatedRecallsItem}
                            </div>
                        </div>
                    </div>
                </div>
            );
        }

        return relatedRecallsDisplay;
    }

    private completeRecallOnClick(recallId: string, e: React.MouseEvent<HTMLAnchorElement>): void {
        e.preventDefault();
        if (this.props.recallCompleteOperation) {
            const operation = new LocalEvent(this.props.recallCompleteOperation);
            operation.AddItem("recallId", recallId);
            LocalEventDispatcher.dispatch(operation);
        }
        else if (this.props.recallCompleteFunction) {
            this.props.recallCompleteFunction(recallId);
        }
    }

    private get showNotification(): boolean {
        return this.isQuestionnaireSet || !!this.props.appointmentEditModel?.get("NotifyPatient");
    }

    private get isQuestionnaireSet(): boolean {
        return cacheStore.ClinicSettings.EnableCovidQuestionnaire && !!this.props.appointmentEditModel?.get("Questionnaire");
    }

    private getSelectedActiveSite(activeSite: SitesModel): SitesModel {
        return activeSite ?? sessionStore.getCurrentEmployee().getActiveSite();
    }

    private openInvitationPopup(): void {
        this.mutateState(patientBannerVerticalState => {
            patientBannerVerticalState.invitationPopupOpen = true;
        });
    }

    private closeInvitationPopup(): void {
        this.mutateState(patientBannerVerticalState => {
            patientBannerVerticalState.invitationPopupOpen = false;
        });
    }

    private isOntarioEnrollmentActive(activeSite: SitesModel): boolean {
        return cacheStore.ClinicSettings.EnableOntarioPatientEnrollment && this.getSelectedActiveSite(activeSite)?.isSiteInProvince(CanadaState.Ontario);
    }

    private async getOntarioEnrollmentStatus(props: IPatientBannerVerticalProps): Promise<void> {
        const patient = props.model.get("Model");

        if (patient) {
            const result = await Client.postAsync<{ PatientEnrollment: OntarioPatientEnrollmentModel }>(
                ServerOperations.Server.Myle_OntarioPatientEnrollment_GetEnrollmentForStatus,
                { PatientId: patient.InactivableResponse.Id }
            );

            if (!result.isSuccess) {
                sessionStore.showPopup(result.errors);
                return;
            }

            this.resetState(this.props.activeSite, result.data?.PatientEnrollment);

            sessionStore.dispatch(
                LocalOperations.Calendar.AppointmentEdit_SetOntarioEnrollmentPatientBanner,
                {
                    enrollmentStatus: result.data?.PatientEnrollment,
                    patient
                }
            );
        }
    }

    private isBritishColumbiaPatient(): boolean {
        return sessionStore.getCurrentEmployee().getActiveSite().isSiteInProvince(CanadaState.BritishColumbia) && this.props.model.get("Model").hasHealthCardInProvince(CanadaState.BritishColumbia);
    }

    private redirectToEnrollment(patientContactId: string): void {
        sessionStore.dispatch(LocalOperations.Misc.RedirectToTab, {
            currentLocation: RouterHistory.location,
            value: patientContactId,
            target: RedirectTo.Patient,
            navigateToSubTab: new HyperLinkRedirectControlPatientProfileSubTabs(ProfileTab.Enrollment)
        });
    }

    private async getPatientLastPortalMessages(patientContactId: string): Promise<void> {
        if (!this.canShowPortalCommunication || !patientContactId)
            return;

        const result = await Client.postAsync<{ PatientPortalMessages: SharedItemMessage[] }>(
            ServerOperations.Server.Myle_PortalCommunication_GetPatientSharedItemMessages,
            { PatientContactId: patientContactId, MaxNumberOfSharedItemMessages: 3 }
        );

        if (result.errors.length) {
            sessionStore.showPopup(result.errors);
            return;
        }

        this.mutateState(s => {
            s.patientPortalMessages = result.data?.PatientPortalMessages;
        });
    }
}

export { PatientBannerVertical };
